import { Line, Text } from '@react-three/drei';
import { useContext, useEffect, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';

export default function MeasureTool() {
  const {
    uuid,
    displayMeasure,
    productsData,
    variantName,
    productVariants,
  } = useContext(CurrentContext);
  const [dimensions, setDimensions] = useState({
    ht: 0,
    wd: 0,
    dep: 0,
    textHeight: 0,
    textWidth: 0,
    textDepth: 0,
  });

  useEffect(() => {
    const current =
      productVariants.length > 1
        ? productVariants.find((product) => product.variant === variantName)
        : productsData.find((product) => product.id === parseInt(uuid));
    if (current) {
      setDimensions({
        ht: current.dimention[2] || 0,
        wd: current.dimention[0] || 0,
        dep: current.dimention[1] || 0,
        textHeight: current.dimentionText[2] || 0,
        textWidth: current.dimentionText[0] || 0,
        textDepth: current.dimentionText[1] || 0,
      });
    }
  }, [variantName]);

  const gap = 0.1;

  const deg90 = Math.PI / 2;
  const deg45 = Math.PI / 4;
  const { ht, wd, dep, textHeight, textWidth, textDepth } = dimensions;

  return (
    <>
      <group visible={displayMeasure}>
        {/* ht */}
        <Line
          points={[
            [-wd / 2 - gap, 0, -dep / 2 - gap],
            [-wd / 2 - gap, ht, -dep / 2 - gap],
          ]}
          color="#000000"
        />
        <Line
          points={[
            [-wd / 2 - gap / 2, ht, -dep / 2 - gap / 2],
            [-wd / 2 - gap, ht, -dep / 2 - gap],
          ]}
          color="#000000"
        />
        <Line
          points={[
            [-wd / 2 - gap / 2, 0, -dep / 2 - gap / 2],
            [-wd / 2 - gap, 0, -dep / 2 - gap],
          ]}
          color="#000000"
        />

        {/* wd */}
        <Line
          points={[
            [wd / 2, 0, dep / 2 + gap],
            [-wd / 2, 0, dep / 2 + gap],
          ]}
          color="#000000"
        />
        <Line
          points={[
            [-wd / 2, 0, dep / 2 + gap / 2],
            [-wd / 2, 0, dep / 2 + gap],
          ]}
          color="#000000"
        />
        <Line
          points={[
            [wd / 2, 0, dep / 2 + gap / 2],
            [wd / 2, 0, dep / 2 + gap],
          ]}
          color="#000000"
        />

        {/* dep */}
        <Line
          points={[
            [-wd / 2 - gap, 0, -dep / 2],
            [-wd / 2 - gap, 0, dep / 2],
          ]}
          color="#000000"
        />
        <Line
          points={[
            [-wd / 2 - gap / 2, 0, -dep / 2],
            [-wd / 2 - gap, 0, -dep / 2],
          ]}
          color="#000000"
        />
        <Line
          points={[
            [-wd / 2 - gap / 2, 0, dep / 2],
            [-wd / 2 - gap, 0, dep / 2],
          ]}
          color="#000000"
        />

        <Text
          position={[-wd / 2 - 1.25 * gap, ht / 2, -dep / 2 - 1.25 * gap]}
          rotation={[0, -deg45, deg90]}
          fontSize={0.075}
          color="#333333"
        >
          {textHeight}
        </Text>
        <Text
          position={[0, gap / 2, dep / 2 + gap]}
          rotation={[-deg45, 0, 0]}
          fontSize={0.075}
          color="#333333"
        >
          {textWidth}
        </Text>
        <Text
          position={[-wd / 2 - gap, gap / 2, 0]}
          rotation={[-deg90, -deg45, -deg90]}
          fontSize={0.075}
          color="#333333"
        >
          {textDepth}
        </Text>
      </group>
    </>
  );
}
